export function roundToNearest1000(value?: number) {
  return !value ? 0 : Math.round(value / 1000) * 1000;
};

export function roundToNearest10(value?: number) {
  return !value ? 0 : Math.round(value / 10) * 10;
};